import { useEffect, useState } from 'react';

interface SplashScreenProps {
  onComplete?: () => void;
  minDisplayTime?: number;
}

export default function SplashScreen({ onComplete, minDisplayTime = 2000 }: SplashScreenProps) {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => {
        onComplete?.();
      }, 500); // Match the fade-out duration
    }, minDisplayTime);

    return () => clearTimeout(timer);
  }, [minDisplayTime, onComplete]);

  return (
    <div
      className={`fixed inset-0 z-50 flex flex-col items-center justify-center bg-gradient-to-b from-[#0a0a18] via-[#0d0d24] to-[#0a0a18] transition-opacity duration-500 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
    >
      {/* Subtle glow effect behind logo */}
      <div className="absolute w-72 h-72 bg-[#1111d4] rounded-full blur-[100px] opacity-15" />

      {/* Main content */}
      <div className="relative flex flex-col items-center">
        {/* Logo */}
        <div className="relative mb-16">
          <img
            src="/images/dartsScheduler-trn.png"
            alt="Darts Scheduler"
            className="w-56 h-56 object-contain"
            style={{ filter: 'drop-shadow(0 0 40px rgba(17, 17, 212, 0.3))' }}
          />
        </div>

        {/* Loading indicator - minimal bar style */}
        <div className="w-48 h-1 bg-[#1a1a3a] rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-[#1111d4] to-[#4444ff] rounded-full animate-loading-bar"
          />
        </div>
      </div>

      {/* Bottom branding */}
      <div className="absolute bottom-8 flex flex-col items-center gap-1">
        <p className="text-gray-500 text-xs tracking-widest uppercase">
          dartscheduler.com
        </p>
        <p className="text-gray-600 text-[10px]">
          v1.0.0
        </p>
      </div>
    </div>
  );
}
